module.exports = __webpack_public_path__ + "static/media/n_service-report-bg@2x.7896adec.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_service-report-bg@2x.png
// module id = 1822
// module chunks = 0 1